export default __webpack_public_path__ + "static/media/plane-seat5.2eb4c5c1.svg";